import React from 'react';
import SectionCompetitorResults from '../shared/SectionCompetitorResults';
import SectionTitle from '../shared/SectionTitle';
import SectionTooltip from '../shared/SectionTooltip';
import { SectionProps } from '../types';
import '../shared/TagListing.less';
import { Tooltip } from 'antd';

function getFontSize(frequency: number) {
    const minFontSize = 14;
    let fontSize = 42;

    if (frequency <= 15) {
        fontSize = minFontSize + 2 * (frequency - 1);
    }

    return fontSize;
}

export default function KeywordsCloudSection({ sectionKey, title, url, relevance, tooltip, result, competitorsResults, passRate }: SectionProps) {
    const hasCompetitors = competitorsResults && Object.keys(competitorsResults).length > 0;

    return (
        <div
            id={sectionKey}
            className="report-element default"
        >
            <SectionTitle title={title} />

            <div className="report-element-description">
                {hasCompetitors && (
                    <div className="description-content">
                        <div className="flexbox align-center">
                            <span className="section-result-url">{url}</span>
                        </div>
                    </div>
                )}

                <KeywordsCloudResult
                    status={result.status}
                    message={result.message}
                    keywordsCloud={result.keywords_cloud}
                />

                {hasCompetitors && (
                    <SectionCompetitorResults
                        results={competitorsResults}
                        relevance={relevance}
                        render={(result) => (
                            <KeywordsCloudResult
                                status={result.status}
                                message={result.message}
                                keywordsCloud={result.keywords_cloud}
                            />
                        )}
                        hideMessage={true}
                    />
                )}
            </div>

            <SectionTooltip tooltip={tooltip} />
        </div>
    );
}

type KeywordsPair = (string | number)[];

type KeywordsCloudResultProps = {
    status: string;
    message: string;
    keywordsCloud: KeywordsPair[];
};

function KeywordsCloudResult({ status, message, keywordsCloud }: KeywordsCloudResultProps) {
    return (
        <>
            {status === 'passed' && keywordsCloud && (
                <div className="description-content">
                    <div className="cloud-tag-listing">
                        {keywordsCloud.map((pair, idx) => (
                            <Tooltip
                                title={`Found ${pair[1]} time${(pair[1] as number) > 1 ? 's' : ''}`}
                                key={idx}
                                placement="bottom"
                                overlayClassName="tooltip-container"
                            >
                                <span style={{ fontSize: getFontSize(pair[1] as number) }}>{pair[0]}</span>
                            </Tooltip>
                        ))}
                    </div>
                </div>
            )}

            {status !== 'passed' && <div dangerouslySetInnerHTML={{ __html: message }} />}
        </>
    );
}
